import React from 'react';
import { setDateFormat } from '../../../../lib/moment';
import OpenBrandDetail from '../../../../components/link/OpenBrandDetail';
import Select from '../../../../components/input/Select';
import TableFilterInput from '../../../../components/table/TableFilterInput';
import DateRangePicker from '../../../../components/datePicker/DateRangePicker';
import Button from '../../../../components/Button';
import {
  addAllItemToSelectList,
  reDirectPage,
  setClearDash,
  setColumnWidth,
  setDetailPageUrl,
  setPhoneFormat,
} from '../../../../lib/common';
import {
  ACCOUNT_SELLER_BUSINESS_TYPE_SELECT_LIST,
  ACCOUNT_SELLER_BUSINESS_TYPE_TEXT,
  ACCOUNT_SELLER_STATUS_TEXT,
} from '../../../../constants/service/app/accountSellerConstants';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import { BRAND_DETAIL_URL_PATH } from '../../../../constants/service/common/urlConstants';
import { setStoreStatus } from '../../../../lib/utils/storeUtils';

/**
 *  입점승인 판매점 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter } = data;

  return [
    {
      Header: '승인하기',
      fixed: 'left',
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="승인하기"
          onClick={() => reDirectPage({ path: setDetailPageUrl(BRAND_DETAIL_URL_PATH, row.original.storeId) })}
        />
      ),
    },
    {
      accessor: 'storeId',
      Header: '상점 ID',
      sortable: true,
      filterable: true,
      fixed: 'left',
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'status',
      Header: '판매점 상태',
      fixed: 'left',
      width: 120,
      Cell: (row) => ACCOUNT_SELLER_STATUS_TEXT[setStoreStatus(row.value, row.original.rejectCnt)],
    },
    {
      accessor: 'createDate',
      Header: '신청일자',
      sortable: true,
      filterable: true,
      fixed: 'left',
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
    {
      accessor: 'confirmDate',
      Header: '처리일자',
      sortable: true,
      filterable: true,
      fixed: 'left',
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.confirmDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ confirmDate: data })}
        />
      ),
    },
    {
      accessor: 'businessType',
      Header: '판매자 유형',
      filterable: true,
      Cell: (row) => ACCOUNT_SELLER_BUSINESS_TYPE_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={addAllItemToSelectList(ACCOUNT_SELLER_BUSINESS_TYPE_SELECT_LIST)}
          onChange={(businessType) => onFilter({ businessType })}
          value={filterOption.businessType}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'storeName',
      Header: '판매점명',
      filterable: true,
      width: setColumnWidth(list, 'storeName'),
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'name',
      Header: '담당자',
      filterable: true,
      width: setColumnWidth(list, 'name'),
      Filter: () => <TableFilterInput option={filterOption.name} onFilter={(name) => onFilter({ name })} />,
    },
    {
      accessor: 'email',
      Header: '이메일',
      filterable: true,
      resizable: true,
      width: setColumnWidth(list, 'email'),
      Filter: () => <TableFilterInput option={filterOption.email} onFilter={(email) => onFilter({ email })} />,
    },
    {
      accessor: 'phone',
      Header: '핸드폰',
      filterable: true,
      width: 170,
      Cell: (row) => setPhoneFormat(row.value),
      Filter: () => (
        <TableFilterInput
          option={filterOption.phone}
          onFilter={(phone) =>
            onFilter({
              phone: setClearDash(phone),
            })
          }
        />
      ),
    },
    {
      accessor: 'extraPhone',
      Header: '유선전화',
      filterable: true,
      width: 170,
      Cell: (row) => setPhoneFormat(row.value),
      Filter: () => (
        <TableFilterInput
          option={filterOption.extraPhone}
          onFilter={(extraPhone) =>
            onFilter({
              extraPhone: setClearDash(extraPhone),
            })
          }
        />
      ),
    },
  ];
};

export default columns;
